import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { startWith, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'migrations-charts',
  templateUrl: './migrations-charts.component.html',
  styleUrls: ['./migrations-charts.component.scss'],
})
export class MigrationsChartsComponent implements OnInit, OnDestroy {
  @Input() successfulMigrations;
  @Input() failedMigrations;
  @Input() isLoadingAccounts;
  @Output() changeChartPeriod = new EventEmitter<string>();

  period = new FormControl('30');

  period$ = this.period.valueChanges.pipe(shareReplay(1), startWith('30'));

  onDestroy$ = new Subject();

  constructor() {
    this.period$
      .pipe(
        takeUntil(this.onDestroy$),
        tap((value) => {
          this.changeChartPeriod.emit(value);
        }),
      )
      .subscribe();
  }

  ngOnInit() {}

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }
}
